import { MatDialogRef } from '@angular/material/dialog';
import { ShipmentPlannerProfileDetails } from '../models';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class ShipmentPlannerProfileItemBriefLoad {
  public static readonly type = '[ShipmentPlannerProfileItemBrief] Load';

  constructor(public payload: number) {}
}

export class ShipmentPlannerProfileItemBriefSave {
  public static readonly type = '[ShipmentPlannerProfileItemBrief] Save';

  constructor(public payload: Partial<ShipmentPlannerProfileDetails>) {}
}

export class ShipmentPlannerProfileItemBriefClone {
  public static readonly type = '[ShipmentPlannerProfileItemBrief] Clone';

  constructor(public payload: Partial<ShipmentPlannerProfileDetails>) {}
}

export class ShipmentPlannerProfileItemBriefDelete {
  public static readonly type = '[ShipmentPlannerProfileItemBrief] Delete';

  constructor(public payload: { dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>; profileId: number }) {}
}

export class ShipmentPlannerProfileItemBriefAffectedUsersLoad {
  public static readonly type = '[ShipmentPlannerProfileItemBrief] Load Default Profile Affected Users';

  constructor(public payload: number) {}
}

export class ShipmentPlannerProfileItemBriefInitialState {
  public static readonly type = '[ShipmentPlannerProfileItemBrief] Set Initial State';
}
